import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { format, parseISO } from 'date-fns';

const { FiMail, FiPhone, FiMessageCircle, FiFileText, FiClock, FiCheckCircle } = FiIcons;

const CommunicationHistoryLog = ({ communications }) => {
  const sortedComms = [...communications].sort((a, b) => new Date(b.date) - new Date(a.date));

  const getTypeIcon = (type) => {
    switch (type) {
      case 'Email': return FiMail;
      case 'Call': return FiPhone;
      case 'SMS': return FiMessageCircle;
      case 'Notice': return FiFileText;
      default: return FiMessageCircle;
    }
  };

  const getTypeStyles = (type) => {
    switch (type) {
      case 'Email': return 'bg-blue-50 text-blue-600';
      case 'Call': return 'bg-green-50 text-green-600';
      case 'SMS': return 'bg-amber-50 text-amber-600';
      case 'Notice': return 'bg-purple-50 text-purple-600';
      default: return 'bg-gray-50 text-gray-600';
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-xs font-black text-gray-400 uppercase tracking-widest flex items-center gap-2">
          <SafeIcon icon={FiClock} className="text-indigo-500" /> Interaction Audit Trail
        </h3>
        <span className="text-[10px] font-bold text-indigo-600 bg-indigo-50 px-2 py-1 rounded uppercase">
          {communications.length} Total Touchpoints
        </span>
      </div>

      <div className="relative pl-8 space-y-6 before:absolute before:inset-0 before:left-[15px] before:w-0.5 before:bg-gray-100 before:content-['']">
        {sortedComms.length === 0 ? (
          <div className="py-12 text-center bg-white rounded-3xl border border-dashed border-gray-200">
            <p className="text-xs text-gray-400 font-bold uppercase tracking-widest">No communication history</p>
          </div>
        ) : (
          sortedComms.map((comm) => (
            <div key={comm.id} className="relative group">
              {/* Timeline Indicator */}
              <div className="absolute -left-[25px] top-1 w-4 h-4 rounded-full border-4 border-white shadow-sm z-10 bg-indigo-500" />
              
              <div className="bg-white rounded-2xl border border-gray-100 p-5 shadow-sm hover:shadow-md transition-all">
                <div className="flex items-start gap-4">
                  <div className={`w-10 h-10 rounded-xl flex items-center justify-center shrink-0 ${getTypeStyles(comm.type)}`}>
                    <SafeIcon icon={getTypeIcon(comm.type)} size={18} />
                  </div>
                  
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center justify-between mb-1">
                      <h4 className="font-black text-gray-900 truncate pr-4">{comm.subject}</h4>
                      <span className="text-[10px] font-bold text-gray-400 uppercase shrink-0">
                        {format(parseISO(comm.date), 'MMM dd, yyyy')}
                      </span>
                    </div>
                    
                    <p className="text-sm text-gray-600 leading-relaxed mb-3">
                      {comm.notes}
                    </p>
                    
                    <div className="flex items-center gap-3 pt-3 border-t border-gray-50">
                      <span className="text-[9px] font-black text-gray-400 uppercase tracking-widest">
                        Status:
                      </span>
                      <span className={`px-2 py-0.5 rounded text-[9px] font-black uppercase tracking-widest flex items-center gap-1 ${
                        comm.status === 'Sent' ? 'bg-green-50 text-green-600' : 'bg-gray-100 text-gray-500'
                      }`}>
                        {comm.status === 'Sent' && <SafeIcon icon={FiCheckCircle} size={10} />}
                        {comm.status}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default CommunicationHistoryLog;